import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteConfirmData } from '@ssi-model/app.types';

@Component({
  selector: 'app-delete-confirm',
  templateUrl: './delete-confirm.component.html',
  styleUrls: ['./delete-confirm.component.css']
})
export class DeleteConfirmComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public  data:DeleteConfirmData) { }

  ngOnInit(): void {
  }

}
